import React from 'react';
import './FeaturedShowcase.css';
function FeaturedShowcase(): React.ReactElement {
  return (
    <section className="featured-showcase" id="showcase">
      <div className="featured-showcase-inner">
        <div className="featured-showcase-content">
          <h2>Featured Work</h2>
          <p className="featured-showcase-intro">
            Handpicked pieces that showcase the artistry and craftsmanship.
          </p>
        </div>
      </div>
    </section>
  );
}

export default FeaturedShowcase;
